/* eslint-disable max-len */
import { Rating, styled } from "@mui/material";

import { paletteColors } from "../muiTheme";

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-icon": {
    color: paletteColors.taupe.light,
  },
  "& .MuiRating-iconFilled": {
    "color": `${paletteColors.primary.main} !important`,
    "& svg": {
      "& path": {
        // Filling color for the path inside the SVG component that we have in ICONS folder
        fill: `${paletteColors.primary.main} !important`,
        // and this stroke is for the our SVG component border color
        stroke: "none",
      },
    },
  },
  "& .MuiRating-iconHover": {
    "color": `${paletteColors.primary.main} !important`,
    "& svg": {
      "& path": {
        // Filling color for the path inside the SVG component that we have in ICONS folder
        fill: `${paletteColors.primary.main} !important`,
      },
    },
  },
}));

export default StyledRating;
